module.exports = __webpack_public_path__ + "img/landing_logo@2x.90f038f1.png";